import apiClient from './apiClient'
import { actionNames as rootActionNames } from '@/store'

export const actionNames = {
  INIT_SUBSCRIPTIONS: 'initSubscriptions',
  CREATE_SUBSCRIPTION: 'createSubscription',
  UPDATE_SUBSCRIPTION: 'updateSubscription',
  DELETE_SUBSCRIPTION: 'deleteSubscription',
  CHANGE_SUBSCRIPTION: 'changeSubscription'
}

export const module = {
  state: {
    subscriptions: []
  },
  mutations: {
    setSubscriptions (state, subscriptions) {
      state.subscriptions = subscriptions
    },
    addSubscription (state, subscription) {
      state.subscriptions = [...state.subscriptions, subscription]
    },
    deleteSubscriptionById (state, subscriptionIdToDelete) {
      state.subscriptions = state.subscriptions.filter(subscription => subscription.id !== subscriptionIdToDelete)
    }
  },
  actions: {
    async [actionNames.INIT_SUBSCRIPTIONS] ({ commit }) {
      commit('setSubscriptions', await apiClient.getSubscription())
    },
    async [actionNames.CREATE_SUBSCRIPTION] ({ commit, dispatch }, { name, quota }) {
      commit('addSubscription', await apiClient.createSubscription(name, Number(quota)))
      dispatch('refresh')
    },
    async [actionNames.UPDATE_SUBSCRIPTION] ({ commit, dispatch }, { id, name, quota }) {
      await apiClient.updateSubscription(id, name, Number(quota))
      dispatch('refresh')
    },
    async [actionNames.DELETE_SUBSCRIPTION] ({ commit, dispatch }, subscriptionId) {
      await apiClient.deleteSubscription(subscriptionId)
      commit('deleteSubscriptionById', subscriptionId)
      dispatch('refresh')
    },
    async [actionNames.CHANGE_SUBSCRIPTION] ({ commit, dispatch, rootState }, subscriptionId) {
      await apiClient.changeSubscription(subscriptionId)
      await dispatch(rootActionNames.INIT_USER, true)
      dispatch('refresh')
    },
    refresh () {
      window.location.reload()
    }
  }
}
